import { trpc } from "@lango/api";
import { Language } from "@lango/api/src/types";

export const useTokens = (text: string, language: Language) => {
  const enabled = text.length > 0;
  const { data, isLoading } = trpc.tokenize.useQuery(
    {
      text,
      language,
    },
    {
      enabled,
    }
  );

  return {
    data,
    isLoading: enabled && isLoading,
  };
};
